import React from 'react';
import { t } from 'ttag';
import {
  Field,
  withTypes,
} from 'react-final-form';

import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { InputLabel } from '@ui/InputLabel';
import { CitySelectContainer, CitySelectOption } from '@containers/CitySelect';

import s from './CityForm.sss';

interface FormData {
  city: CitySelectOption,
}

interface Props {
  initialValues: FormData,
  onSubmit: (data: FormData) => void,
}

export const CityForm: React.FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { Form } = withTypes<FormData>();

  return (
    (
      <div className={s.root}>
        <Title
          type="h3"
          bold={false}
        >
          {t`Вкажіть, будь ласка, ваше місто`}
        </Title>
        <p className={s.description}>
          {t`Ми зможемо знайти цікаві пропозиції від продавців з вашого міста`}
        </p>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ handleSubmit }) => (
            <form
              className={s.form}
              onSubmit={handleSubmit}
            >
              <InputLabel className={s.label}>
                {t`Місто`}
              </InputLabel>
              <Field<CitySelectOption>
                name="city"
              >
                {({ input }) => (
                  <CitySelectContainer
                    {...input}
                    className={s.input}
                    placeholder={t`Ввести місто`}
                  />
                )}
              </Field>

              <Button
                type="submit"
                className={s.submit}
              >
                {t`Продовжити`}
              </Button>
            </form>
          )}
        </Form>
      </div>
    )
  );
};
